export default function (tableId, cellIndex, desc) {
  var table, rows, switching, i, x, y, xVal, yVal, shouldSwitch;
  table = document.getElementById(tableId);
  switching = true;
  if (table) {
    while (switching) {
      switching = false;
      rows = table.rows;

      for (i = 1; i < rows.length - 1; i++) {
        // Start by saying there should be no switching:
        shouldSwitch = false;
        /* Get the two elements you want to compare,
        one from current row and one from the next: */
        x = rows[i].getElementsByTagName("TD")[cellIndex];
        xVal = x.getAttribute("data-val")
          ? x.getAttribute("data-val")
          : x.innerHTML.toLowerCase();

        y = rows[i + 1].getElementsByTagName("TD")[cellIndex];
        yVal = y.getAttribute("data-val")
          ? y.getAttribute("data-val")
          : y.innerHTML.toLowerCase();

        if (!isNaN(parseFloat(xVal))) {
          xVal = parseFloat(xVal);
        }
        if (!isNaN(parseFloat(yVal))) {
          yVal = parseFloat(yVal);
        }

        if ((desc && xVal < yVal) || (!desc && xVal > yVal)) {
          // If so, mark as a switch and break the loop:
          shouldSwitch = true;
          break;
        }
      }
      if (shouldSwitch) {
        /* If a switch has been marked, make the switch
        and mark that a switch has been done: */
        rows[i].parentNode.insertBefore(rows[i + 1], rows[i]);
        switching = true;
      }
    }
  }
}



// WEBPACK FOOTER //
// ./scripts/util/sortTable.js